import { render, staticRenderFns } from "./ChallengeForfeitTeamActionMenu.vue?vue&type=template&id=c3143324&scoped=true&lang=pug&"
import script from "./ChallengeForfeitTeamActionMenu.vue?vue&type=script&lang=js&"
export * from "./ChallengeForfeitTeamActionMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3143324",
  null
  
)

export default component.exports